import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const RecircByTag = ({ articles, recircRef }) => {
  const [hide, setHide] = useState(null);

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 639px)');
    mql.addEventListener('change', () => setHide(mql.matches));
    setHide(window.innerWidth <= 639);
  }, []);

  // Articles for this module are handled by a data call in src/views/containers/pages/post_page/post_page.js
  if (hide || !articles) return false;

  return (
    <aside className="article-recirc-by-tag" ref={recircRef}>
      <div className="header">
        <div className="top-arrow">
          <img
            src="https://images.fastcompany.net/image/upload/v1595605760/fcweb/Path_33_zlkv0h.svg"
            alt=""
          />
        </div>

        <div className="package-name">More Like This</div>
      </div>

      <div className="articles">
        {articles.map(article => (
          <div className="article" key={article.title}>
            <a
              href={`${article.link}&icid=dan902:754:0:editRecirc`}
              dangerouslySetInnerHTML={{ __html: article.title }}
            />
          </div>
        ))}
      </div>
    </aside>
  );
};

RecircByTag.propTypes = {
  articles: PropTypes.shape([]),
  recircRef: PropTypes.node
};

RecircByTag.defaultProps = {
  articles: null,
  recircRef: null
};

export default RecircByTag;
